import React, { useEffect } from "react";
import "./VirasatV2DefaultHomePage.scss"
import VirasatV2DefaultHeroPage from "./VirasatV2DefaultHeroPage";
import VirasatV2DefaultStoryPage from "./VirasatV2DefaultStoryPage";
import VirasatV2DefaultServicesPage from "./VirasatV2DefaultServicesPage";
import VirasatV2DefaultExpPage from "./VirasatV2DefaultExpPage";
import VirasatV2DefaultGalleryPage from "./VirasatV2DefaultGalleryPage";
import VirasatV2DefaultResPage from "./VirasatV2DefaultResPage";
import { useDispatch, useSelector } from "react-redux";
import { sortByOrderAscending } from "../../helper/helper";
import { useHistory } from "react-router";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";
import BlogComponent from "../../../Blog/BlogComponent/BlogComponent";

const VirasatV2DefaultHomePage = () => {
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "home")
    const Components = page?.Components || []
    const history = useHistory()
    const dispatch = useDispatch()
    useEffect(() => {
        window.scrollTo(0, 0);
        if (Components.length === 0) {
            history.push("/coming-soon")
        }
    }, []);
    const getFixedContent = (component) => {
        return (<div className="VirasatV2Default-MobileFixed">
            {component.map((component, key) => {
                let page = component?.Props
                return (<div className="VirasatV2Default-MobileFixed-cont" key={key}
                    onClick={() => {
                        if (page?.href?.includes("https://")) {
                            if (page?.href && page?.href !== "") {
                                window.open(page?.href, '_blank')
                            }
                            else {
                                dispatch(setIsComing(true))

                            }
                        } else {
                            history.push(page?.href)
                        }
                    }}>{page?.icon && <img alt="" src={page?.icon} />}{page?.text}</div>)
            })}

        </div>)
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultHeroPage":
                return <VirasatV2DefaultHeroPage components={component.Components} heroBackground={component?.Props?.bgSrc} />
            case "VirsatDefaultStoryPage":
                return <VirasatV2DefaultStoryPage components={component.Components} />
            case "VirasatDefaultServicesPage":
                return <VirasatV2DefaultServicesPage components={component.Components} />
            case "VirasatDefaultExpPage":
                return <VirasatV2DefaultExpPage components={component.Components} />
            case "VirasatDefaultGalleryPage":
                return <VirasatV2DefaultGalleryPage components={component.Components} />
            case "VirasatDefaultResPage":
                return <VirasatV2DefaultResPage components={component.Components} props={component?.Props} />
            case "VirasatV2DefaultMobileFixed":
                return getFixedContent(component.Components)
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatV2DefaultHomePage" >
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
            <BlogComponent />
        </div>
    )
}
export default VirasatV2DefaultHomePage